import type { AppConfig } from "../../types/appConfig";
import { assertResponseOk, expectStatuses, fetchZekay } from "../zekay/httpClient";
import type { FollowUpSheet, Dive } from "./Followup.typed";

export class FollowupModel {
  zekayAPI: string;
  constructor(config: AppConfig) {
    this.zekayAPI = config.zekayAPI;
  }
  async getFollowUpSheet(
    templateId: number,
    customerId: number,
  ): Promise<FollowUpSheet | undefined> {
    const r = await fetchZekay(`${this.zekayAPI}/followupsheets/${templateId}/${customerId}`);
    if (r.status === 404) return undefined;
    await assertResponseOk(r);
    return (await r.json()) as FollowUpSheet;
  }
  async createFollowUpSheet(sheet: FollowUpSheet): Promise<void> {
    const payload = {
      ...sheet,
      TrainingTemplateID: sheet.TrainingTemplateID,
    };
    const r = await fetchZekay(`${this.zekayAPI}/followupsheets/create`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    await expectStatuses(r, 201);
  }
  async updateFollowUpSheet(sheet: FollowUpSheet): Promise<FollowUpSheet> {
    const r = await fetchZekay(`${this.zekayAPI}/followupsheets/update`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(sheet),
    });
    await assertResponseOk(r);
    return (await r.json()) as FollowUpSheet;
  }
  async getDives(templateId: number, customerId: number): Promise<Dive[]> {
    const r = await fetchZekay(`${this.zekayAPI}/dives/${templateId}/${customerId}`);
    await expectStatuses(r, 200, 204);
    if (r.status === 204) return [];
    return (await r.json()) as Dive[];
  }
  async updateDives(templateId: number, customerId: number, dives: Dive[]): Promise<Dive[]> {
    const r = await fetchZekay(`${this.zekayAPI}/dives/${templateId}/${customerId}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(dives),
    });
    await expectStatuses(r, 200, 204);
    if (r.status === 204) return dives;
    return (await r.json()) as Dive[];
  }
}
